<template lang="pug">
  .base
    .row
      h2
        img(:src="imagePath + 'img/finger.png'")
        span 専門家からのアドバイス
    .span(v-for="label, i in title" :key="i")
      .row
        h3
          span.orange {{title[i]}}
      .row
        .message {{message[i]}}
    .span(v-for="label, i in mode" :key="i" v-if="label == 5")
      .row
        h3
          span.orange 以下のケースは特に要注意です。いますぐ専門家へご相談ください。
      .row
        .message
          table
            tr
              th 相続人が兄弟姉妹のみ
              td 仲の悪い兄弟姉妹に財産が渡ってしまう可能性があります。遺言をすることをご検討ください。
            tr
              th 相続人が配偶者と兄弟姉妹
              td 配偶者がご自身の兄弟姉妹と遺産分割協議をしなければならなくなります。良好な関係にない場合、配偶者に大変な思いをさせる可能性があります。配偶者に手続負担をかけない形で遺言をすることをご検討ください。
            tr
              th 相続人の中に甥姪がいる場合
              td 会ったこともない甥、姪にあなたの財産が相続されてしまう可能性があります。遺言をすることをご検討ください。
            tr
              th 相続人が配偶者と兄弟姉妹、甥姪の場合
              td 配偶者があなたの兄弟姉妹や甥姪と遺産分割協議をしなければならなくなり、配偶者に苦労をかけてしまう可能性があります。遺言をすることをご検討ください。
            tr
              th 現在の配偶者との間の子供以外に子どもがいる場合
              td 長年会っていない子供に財産が渡ってしまう可能性があります。遺言や生前贈与、保険などで争族対策を検討しましょう。
            tr
              th 現在の配偶者との間には子供がおらず、前妻との間の子や認知した婚外子がいる
              td 配偶者に十分な遺産を残せない可能性があります。遺言や生前贈与、保険などで争族対策を検討しましょう。
    .row
      .button_area
        button.blue_button(@click="go_mail")
          | 当サイトの専門家に
          br
          | 無料メール相談をする

</template>

<script lang="js">
import step03Module from '@/module/step03Module';
import RowItemTemplate from '@/components/step03/RowItemTemplate.vue';

export default {
  components: {
    RowItemTemplate,
  },
  data: () => ({
    mode: [],
  }),
  props: {
    イ: {
      type: Number,
      default: 0,
    },
    ハ: {
      type: Number,
      default: 0,
    },
    ニ: {
      type: Number,
      default: 0,
    },
    taxPrice: {
      type: Number,
      default: 0,
    },
    priceData: {
      type: Object,
      default: {},
    },
    targetMemberCount: {
      type: Object,
      default: {},
    },
  },
  watch: {
    targetMemberCount() {
      this.createText();
    },
  },
  computed: {
    title() {
      const data = [];
      for (const mode of this.mode) {
        switch (mode) {
          case 1:
            data.push('現状では納税資金の心配はありませんが・・・');
            break;
          case 2:
            data.push('現状では納税資金が不足しています！事前準備が必要です！ ');
            break;
          case 3:
            data.push('死亡保険金が非課税限度額を下回っています。');
            break;
          case 4:
            data.push('もし被相続人に債務があることが判明した場合は注意が必要です。');
            break;
          case 5:
            data.push('相続人が複数いる場合、相続でトラブルに発展するケースも！長期化を防ぐためには！？ ');
            break;
          case 6:
            data.push('相続税は発生しませんが、このまま相続すると債務がのしかかってきます。');
            break;
          case 9:
            data.push('相続人の検討を！遺産は国庫に帰属され国のものになるかも・・・');
            break;
        }
      }
      return data;
    },
    message() {
      const data = [];
      for (const mode of this.mode) {
        switch (mode) {
          case 1:
            data.push('相続税の納税は、現預金の範囲内なので心配ありません。しかし現預金を違う財産に変えることで相続税の対策になる可能性がありますので、一度 専門家へ相談してみることをオススメします。');
            break;
          case 2:
            data.push('相続税は現金一括納付が原則です。現金納付が困難な場合は、分割納付 ( 延納 ) や、株式・不動産等による納付 ( 物納 ) があります。納税資金の準備と、誰に何を相続させるか検討する必要があります。弁護士や税理士へご相談を。');
            break;
          case 3:
            data.push('死亡保険金には、相続税が課からない制度(非課税枠)があります。現状では非課税枠があまってますので、現預金を保険に変えることに より相続税対策が可能です。一度、専門家へご相談されることをオススメします。');
            break;
          case 4:
            data.push('相続人はあなた一人です。もし故人に財産を上回る借金があった場合、その借金も背負うことになります。そんなケースの場合は、亡くなった日から３カ月以内に、相続放棄や限定承認という手続きを裁判所へする必要があります。一度、弁護士や税理士にご相談されることをオススメします。');
            break;
          case 5:
            data.push('仲の良い親子関係、兄弟姉妹関係であっても、それぞれの生活環境は違います。故人のお世話をしていた、生前に財産贈与を受けていたなど、様々な理由でもめるケース(争族) が多々あります。もしご生前の場合は、争族を回避する手段として遺言書の作成をオススメします。事前に財産等の把握と分割シミュレーションをして、円満相続が可能となります。また生前・死後に関わらず親族間で争いに発展する可能性がありますので、一度弁護士や税理士にご相談されることをオススメします。');
            break;
          case 6:
            data.push('もし故人に財産を上回る借金があり相続した場合、その借金も背負うことになります。このようなケースの場合、亡くなった日から３カ月以内に裁判所へ、相続放棄や限定承認という手続きをする方法があります。一度、弁護士や税理士にご相談されることをオススメします。少額の債務であった場合でも、債務を引き継ぐことになりますので特にご注意ください。');
            break;
          case 9:
            data.push('現状では、遺産は最終的に国のものになります。身近な人へ渡したい場合は、養子縁組や遺言書作成により可能となります。一度、弁護士や税理士へご相談されることをオススメします。');
            break;
        }
      }
      return data;
    },
    imagePath() {
      return process.env.BASE_URL;
    },
  },
  mounted() {
    this.createText();
  },
  methods: {
    go_mail(e) {
      this.$emit('go_mail');
    },
    createText() {
      this.mode = [];
      if (this.priceData.price < 0) {
        this.mode.push(6);
      } else if (this.targetMemberCount.total === 0) {
        this.mode.push(9);
      } else {
        if (this.priceData.style === 1) {
          const havePrice = this.priceData.price01 + this.priceData.price03;
          if (this.taxPrice > havePrice) {
            this.mode.push(2);
          } else {
            this.mode.push(1);
          }
          if (this.priceData.price03 < (this.targetMemberCount.total * 500)) {
            this.mode.push(3);
          }
        }
        if (this.targetMemberCount.total === 1) {
          this.mode.push(4);
        } else {
          this.mode.push(5);
        }
      }

      this.$emit('expert_data', {title: this.title, message: this.message, mode: this.mode});
    },
  },
};
</script>

<style lang="sass" scoped>
.base
  width: 100%
  margin-top: 40px
  margin-bottom: 80px
  .row
    h2
      display: flex
      align-items: center
      img
        width: 30px
        margin-right: 10px
    h3
      margin-top: 10px
      font-size: 1.5em
    .message
      margin-top: 10px
      table
        width: 100%
        border-collapse: collapse
        th, td
          border: solid 1px $color-black
          padding: 5px
          font-size: 90%
        th
          font-weight: normal
          text-align: left
    .button_area
      margin-top: 40px
      button
        width: 100%
        max-width: 360px
.orange
  color: $color-orange!important
</style>